import { http } from '../axios';
import { libraryManagedConfig } from '../../config';


export type UpdateProductGroupRequest = {
    title: string;
    sorting: string
}

export type ApiUpdateProductGroup = {
    productGroupId: number | string
    body: UpdateProductGroupRequest
}

export const updateProductGroup = ({ productGroupId, body }: ApiUpdateProductGroup) => {
    return http.put(libraryManagedConfig().endpointProductGroupSortAndTitle, body, {
        pathParams: { productGroupId }
    });
};
